import AlbumsPage from './AlbumsPage';

export default AlbumsPage;
